import { _ } from "../../core/polyglot/polyglot.js";
import AbstractDeviationType from "./AbstractDeviationType.js";

/**
 * Percentage Deviation Type expresses the deviation with a percentage.
 */
export default class PercentageDeviationType extends AbstractDeviationType {
	getLabel() {
		return _("Percentage");
	}

	makeDeviationColumnTemplate(spec) {
		return this._makeDeviationColumnTemplate({
			...spec,
			inPercent: true,
		});
	}

	static getType() {
		return "PercentageDeviationType";
	}
}
